import {HttpClient} from "../../service/httpClient/HttpClient";

export class ProductVariantService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getProductVariantList(id, page, size, title, slug) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products/${id}/variants`,
                {
                    page,
                    size,
                    title,
                    slug
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewVariant(id, title, price, compareAtPrice) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `products/${id}/variants`,
                {
                    title,
                    price,
                    compareAtPrice
                }
            ).then(resolve).catch(reject)
        })
    }

    getProductVariantInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products/variants/${id}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateProductVariantInfo(id, title, price, compareAtPrice, weight) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `products/variants/${id}/information`,
                {
                    title,
                    price,
                    compareAtPrice,
                    weight
                }
            ).then(resolve).catch(reject)
        })
    }

    getProductVariantSku(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products/variants/${id}/sku`
            ).then(resolve).catch(reject)
        })
    }

    updateProductVariantSku(id, sku) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `products/variants/${id}/sku`,
                {},
                {
                    sku
                }
            ).then(resolve).catch(reject)
        })
    }

    getProductVariantEnabled(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products/variants/${id}/enabled`
            ).then(resolve).then(reject)
        })

    }

    updateProductVariantEnabled(id, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `products/variants/${id}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getProductVariantDefault(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products/variants/${id}/default`
            ).then(resolve).catch(reject)
        })
    }

    updateProductVariantDefault(id, productVariantDefault) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `products/variants/${id}/default`,
                {},
                {
                    "default": productVariantDefault
                }
            ).then(resolve).catch(reject)
        })

    }

    getAllProductVariantSelection(id){
        return new Promise((resolve, reject)=>{
            this.httpClient.get(
                `products/${id}/variants/selections`
            ).then(resolve).catch(reject)
        })
    }

}